import { useEffect,useState } from "react";
import { Switch } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import DatePickerKendoRct from "../../../../control-components/date-picker/date-picker";
import ClientHeader from "../client-header/client-header";
import ErrorHelper from "../../../../helper/error-helper";
import { NotificationManager } from "react-notifications";
import DropDownKendoRct from "../../../../control-components/drop-down/drop-down";
import InputKendoRct from "../../../../control-components/input/input";
import Loader from "../../../../control-components/loader/loader";
import { useSelector } from "react-redux";
import { ClientService } from "../../../../services/clientService";
import TextAreaKendoRct from "../../../../control-components/text-area/text-area";
import MultiSelectDropDown from "../../../../control-components/multi-select-drop-down/multi-select-drop-down";
import { useNavigate, useLocation } from "react-router";
import ValidationHelper from "../../../../helper/validation-helper";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { renderErrors } from "src/helper/error-message-helper";
import { API_ENDPOINTS } from "src/services/api-endpoints";
import calenderIcon from "../../../../assets/images/calendar-03.png"
import { customAxios } from "src/services/useExPressApi";
import DropDownListComponent from "src/control-components/drop-down-component/drop-down";


const CommonAuthorizationForm = () => {
  const frequencyData = [
    { key: "Day", value: "Day" },
    { key: "Week", value: "Week" },
    { key: "Month", value: "Month" },
    { key: "Year", value: "Year" },
  ];
  const vHelper = ValidationHelper();
  const staffLoginInfo = useSelector((state) => state.getStaffReducer);

  const submittedByd = {
    name: `${staffLoginInfo?.lastName}, ${staffLoginInfo?.firstName}`,
    id: staffLoginInfo?.id,
  };

  let [fields, setFields] = useState({
    effectiveDate: "",
    endDate: "",
    numUnits: "",
    // dateAuth: "",
    authStatus: "",
    submittedDate: "",
    submittedBy: submittedByd,
    comments: "",
    custAuthId: "",
    authServices: "",
    isEnforceValidation: true,
    freqNumUnits: 0,
    frequency: { key: "Day", value: "Day" },
    clientId: "",
  });
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [settingError, setSettingError] = useState(false);
  const [authStatus, setAuthStatus] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const staffId = useSelector((state) => state.loggedIn?.staffId);
  const clinicId = useSelector((state) => state.loggedIn.clinicId);
  const [clientList, setClientList] = useState([]);
  const navigate = useNavigate();
  const [totalnumValidation, setTotalnumValidation] = useState(false)

  const [serviceData, setServiceData] = useState([]);
  const { state } = useLocation();

  useEffect(() => {
    getAuthorizationStatus();
    getStaffList();
    getServicesList();
    fetchClientList();

    if (state) {
      getAuthorizationtById();
    }
  }, []);

  function fetchClientList() {
    setLoading({ patientList: true });
    customAxios.get(API_ENDPOINTS.GET_CLIENT_DDL_BY_CLINIC_ID+true)
      .then((result) => {
        const list = result.resultData.map((r) => {
          return { id: r.clientId, name: r.clientName };
        });
        setClientList(list);
      })
      .catch((err) => {
        setErrors(err, "Patient List");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const getAuthorizationtById = async () => {
    setLoading(true);
    await ClientService.getAuthById(state.selectedAuthorization)
      .then((result) => {
        setLoading(false);
        let authInfo = result.resultData;
        let services = result.resultData.serviceIds;
        let newData = [];
        if (services.length > 0) {
          for (var i = 0; i < services.length; i++) {
            const element = {
              id: services[i]?.id,
              fullName: services[i]?.name,
            };
            newData.push(element);
          }
        }
        const clientId = {
          id: authInfo?.clientId,
          name: authInfo?.clientName,
        };
        const authStatus = {
          id: authInfo?.authStatusId,
          name: authInfo?.authStatus,
        };
        const authSubmitted = {
          id: authInfo?.staffId,
          name: authInfo?.submittedByStaffName,
        };
        const frequencyVal = {
          key: authInfo?.frequency,
          value: authInfo?.frequency,
        };

        setFields({
          ...fields,
          effectiveDate:
            authInfo?.effectiveDate && new Date(authInfo.effectiveDate),
          endDate: authInfo?.endDate && new Date(authInfo.endDate),
          submittedDate:
            authInfo?.dateSubmitted && new Date(authInfo.dateSubmitted),
          // dateAuth: authInfo?.dateAuth && new Date(authInfo.dateAuth),
          numUnits: authInfo?.numUnits,
          comments: authInfo?.comments,
          custAuthId: authInfo?.custAuthId,
          authStatus: authStatus !== null && authStatus,
          submittedBy: authSubmitted !== null && authSubmitted,
          authServices: newData,
          isEnforceValidation: authInfo?.isEnforceValidation,
          freqNumUnits: authInfo?.freqNumUnits,
          frequency: frequencyVal !== null && frequencyVal,
          clientId: clientId !== null && clientId,
        });
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error.message);
      });
  };

  const getAuthorizationStatus = async () => {
    await ClientService.getAuthorizationStatus()
      .then((result) => {
        let list = result.resultData;

        setAuthStatus(list);
      })
      .catch((error) => {
        renderErrors(error);
      });
  };

  const getStaffList = async () => {
    await ClientService.getStaffDDLByClinicId()
      .then((result) => {
        let list = result.resultData;
        setStaffData(list);
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error);
      });
  };
  const getServicesList = () => {
    const data = {
      isActive: true,
      siteIds: []
    }
    customAxios.post(
      API_ENDPOINTS.GET_SERVICE_BY_PROVIDER_ID, data
    )
      .then((result) => {
        setServiceData(result.resultData);
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error.message);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.clientId && !selectedClientId) {
      formIsValid = false;
      errors["clientId"] = ErrorHelper.FIELD_BLANK;
    }

    if (!fields.numUnits) {
      formIsValid = false;
      errors["numUnits"] = ErrorHelper.TOTAL_UNIT;
    }

    if (!fields.effectiveDate) {
      formIsValid = false;
      errors["effectiveDate"] = ErrorHelper.FIELD_BLANK;
    }
    else if (fields.effectiveDate && fields.endDate) {
      let error = vHelper.startDateLessThanEndDateValidator(
        fields.effectiveDate,
        fields.endDate,
        "effectiveDate",
        "endDate"
      );
      if (error && error.length > 0) {
        errors["effectiveDate"] = error;
        formIsValid = false;
      }
    }
    if (!fields.endDate) {
      formIsValid = false;
      errors["endDate"] = ErrorHelper.FIELD_BLANK;
    }
    // if (!fields.dateAuth) {
    //   formIsValid = false;
    //   errors["dateAuth"] = ErrorHelper.FIELD_BLANK;
    // }
    if (!fields.submittedDate) {
      formIsValid = false;
      errors["submittedDate"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.authStatus) {
      formIsValid = false;
      errors["authStatus"] = ErrorHelper.FIELD_BLANK;
    }
    if (fields.authServices.length === 0) {
      formIsValid = false;
      errors["authServices"] = ErrorHelper.FIELD_BLANK;
    }

    if (!fields.submittedBy) {
      formIsValid = false;
      errors["submittedBy"] = ErrorHelper.FIELD_BLANK;
    }

    if (
      fields.isEnforceValidation && (!fields.freqNumUnits || fields.freqNumUnits < 1)
    ) {
      formIsValid = false;
      errors["freqNumUnits"] = ErrorHelper.GREATER_THEN_ZERO;
    }

    if (!fields.frequency) {
      formIsValid = false;
      errors["frequency"] = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    let name = e.target.name || e.target.props.name;
    const value = e.target.value;
    // if (name === "freqNumUnits") {
    //   if (value < 0) {
    //     return;
    //   }
    // } else {
    setFields({
      ...fields,
      [name]: value,
    });
    // }
  };

  const handleTextChange = (e) => {
    const name = e.target.name;
    const value = e.value;

    setFields({
      ...fields,
      [name]: value,
    });
  };

  const saveAuthorization = async () => {
    setLoading(true);
    await ClientService.saveAuthorization(fields, selectedClientId, staffId)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Authorization added successfully");
        navigate(-1);
        setFields({
          ...fields,
          effectiveDate: "",
          endDate: "",
          numUnits: "",
          // dateAuth: "",
          authStatus: "",
          submittedDate: "",
          submittedBy: "",
          comments: "",
          custAuthId: "",
          authServices: "",
          isEnforceValidation: "",
          freqNumUnits: "",
          frequency: "",
          clientId: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error);
      });
  };

  const updateAuthorization = async (authId) => {
    setLoading(true);
    await ClientService.updateAuthorization(
      fields,
      selectedClientId,
      staffId,
      authId
    )
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Authorization updated successfully");
        navigate(-1);
        setFields({
          ...fields,
          effectiveDate: "",
          endDate: "",
          numUnits: "",
          // dateAuth: "",
          authStatus: "",
          submittedDate: "",
          submittedBy: "",
          comments: "",
          custAuthId: "",
          authServices: "",
          isEnforceValidation: "",
          freqNumUnits: "",
          frequency: "",
          clientId: "",
        });
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error);
      });
  };

  const handleSubmit = () => {
    setTotalnumValidation(true)
    setSettingError(true);
    if (handleValidation()) {
      if (state) {
        updateAuthorization(state.selectedAuthorization);
      } else {
        saveAuthorization();
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="container-fluid col-md-9 col-lg-10 blue_theme">
        <div className="staff-profile-page">
          {selectedClientId ? <ClientHeader /> : ""}
          <div className="upload-sign-file pt_30">
            <div className="d-flex justify-content-between ">
              <h4 className="address-title text-grey ">
                <span className="f-24">Authorization</span>
              </h4>
            </div>
          </div>
          <div className="row mt-3 m-0">
            {selectedClientId ? (
              " "
            ) : (
              <div className="mb-2 col-lg-4 col-md-6 col-12">
                <DropDownKendoRct
                  label="Client"
                  onChange={handleChange}
                  value={fields.clientId}
                  textField="name"
                  name="clientId"
                  data={clientList}
                  required={true}
                  dataItemKey="id"
                  validityStyles={settingError}
                  error={!fields.clientId && errors.clientId}
                  placeholder="Client"
                  disabled={state?.selectedAuthorization ? true : false}
                />
              </div>
            )}
            <div className="mb-2 col-lg-4 col-md-6 col-12 position-relative ">
              <DatePickerKendoRct
                onChange={handleChange}
                format={"MM/dd/YYYY"}
                placeholder=""
                value={fields.submittedDate}
                name={"submittedDate"}
                fillMode={"solid"}
                size={"medium"}
                title={"Date of Request Submission"}
                label={"Date of Request Submission"}
                weekNumber={false}
                required={true}
                validityStyles={settingError}
                error={!fields.submittedDate && errors.submittedDate}
              />
              <img src={calenderIcon} className="blueThemeIcons" alt="calender"/>
            </div>
            <div className="mb-2 col-lg-4 col-md-6 col-12">
              <label className="k-label">Total Units</label>
              <NumericTextBox
                value={fields.numUnits}
                onChange={handleChange}
                name="numUnits"
                style={{ marginTop: -4 }}
                validityStyles={settingError}
                required={true}
                placeholder="Total Units"
                spinners={false}
              />
              {!fields.numUnits && <Error>{errors.numUnits}</Error>}
            </div>
            <div className="mb-2 col-lg-4 col-md-6 col-12 position-relative ">
              <DatePickerKendoRct
                onChange={handleChange}
                format={"MM/dd/YYYY"}
                placeholder=""
                value={fields.effectiveDate}
                name={"effectiveDate"}
                fillMode={"solid"}
                size={"medium"}
                title={"Effective Date"}
                label={"Effective Date"}
                weekNumber={false}
                required={true}
                validityStyles={settingError}
                error={!fields.effectiveDate && errors.effectiveDate}
              />
              <img src={calenderIcon} className="blueThemeIcons" alt="calender"/>
            </div>

            <div className="mb-2 col-lg-4 col-md-6 col-12 position-relative">
              <DatePickerKendoRct
                onChange={handleChange}
                format={"MM/dd/YYYY"}
                placeholder=""
                value={fields.endDate}
                name={"endDate"}
                fillMode={"solid"}
                size={"medium"}
                title={"End Date"}
                label={"End Date"}
                weekNumber={false}
                required={true}
                validityStyles={settingError}
                error={!fields.endDate && errors.endDate}
              /><img src={calenderIcon} className="blueThemeIcons" alt="calender"/>
            </div>

            {/* <div className="mb-2 col-lg-4 col-md-6 col-12">
              <DatePickerKendoRct
                onChange={handleChange}
                format={"MM/dd/YYYY"}
                placeholder=""
                value={fields.dateAuth}
                name={"dateAuth"}
                fillMode={"solid"}
                size={"medium"}
                label={"Auth Date"}
                weekNumber={false}
                required={true}
                validityStyles={settingError}
                error={!fields.dateAuth && errors.dateAuth}
              />
            </div> */}

            <div className="mb-2 col-lg-4 col-md-6 col-12">
              <DropDownKendoRct
                label="Status"
                onChange={handleChange}
                value={fields.authStatus}
                textField="name"
                name="authStatus"
                data={authStatus}
                required={true}
                dataItemKey="id"
                validityStyles={settingError}
                error={!fields.authStatus && errors.authStatus}
                placeholder="Status"
              />
            </div>

            <div className="mb-2 col-lg-4 col-md-6 col-12">
              <DropDownKendoRct
                label="Submitted By"
                onChange={handleChange}
                value={fields.submittedBy}
                textField="name"
                name="submittedBy"
                data={staffData}
                required={true}
                dataItemKey="id"
                validityStyles={settingError}
                error={!fields.submittedBy && errors.submittedBy}
                placeholder="Submitted By"
              />
            </div>
            <div className="mb-2 col-lg-4 col-md-6 col-12">
              <InputKendoRct
                value={fields.custAuthId}
                onChange={handleTextChange}
                name="custAuthId"
                label="Auth ID"
                placeholder="Auth ID"
              />
            </div>
            <div className="mb-2 col-lg-12 col-md-12 col-12">
              <MultiSelectDropDown
                label="Auth Services"
                onChange={handleChange}
                data={serviceData}
                value={fields.authServices}
                textField="fullName"
                name="authServices"
                dataItemKey="id"
                validityStyles={settingError}
                required={true}
                error={fields.authServices.length === 0 && errors.authServices}
              />
            </div>
            <div className="mb-2 col-lg-12 col-md-12 col-12">
              <TextAreaKendoRct
                txtValue={fields.comments}
                onChange={handleTextChange}
                name="comments"
                label="Comments"
                rows={1}
              />
            </div>

            <div className="mb-2 col-lg-12 col-md-12 col-12">

              <Switch
                onChange={handleChange}
                checked={fields.isEnforceValidation}
                onLabel={""}
                offLabel={""}
                name="isEnforceValidation"
              />
              <span className="mr-2">Restrictive?</span>
            </div>
            {/* start */}
            <div className="frequency mb-3">
              <div className="">
                <div className="col-md-12 d-flex align-items-center dropIcon">
                  <p className="mt-2">if yes, Client is limited to</p>
                  <NumericTextBox
                    style={{ width: "80px" }}
                    value={fields.freqNumUnits}
                    onChange={handleChange}
                    name="freqNumUnits"
                    validityStyles={settingError}
                    required={true}
                    spinners={false}
                  />
                  {errors && (
                    <Error style={{ position: "absolute", top: "30px" }}>
                      {errors.freqNumUnits}
                    </Error>
                  )}
                  <p className="ml-2 mt-2">units per</p>
                  <div className="auth-drop-error ">
                    <DropDownListComponent
                      defaultValue={frequencyData[0].value}
                      data={frequencyData}
                      textField="value"
                      dataItemKey="key"
                      value={fields.frequency}
                      onChange={handleChange}
                      name="frequency"
                      className="frequency-drop"
                      error={fields.frequency.length === 0 && errors.frequency}
                      required={true}
                    />
                    {!fields.frequency && <Error>{errors.frequency}</Error>}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {loading === true && <Loader />}

        <div className="row my-2 m-0">
          <div className="d-flex">
            <div>
              <button
                onClick={handleSubmit}
                className="submitButon "
              >
                Submit
              </button>
            </div>
            <div>
              <button
                className="cancelBtn "
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonAuthorizationForm;
